import { useCallback, useMemo, useState } from "react";
import { flags as backupFlags } from "utils/feature-flags";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import "firebase/compat/firestore";
import useMount from "./useMount";

const useFeatureFlag = () => {
  const [userEmail, setUserEmail] = useState(null);
  const backUpFeatureFlags = useMemo(() => {
    const ff = {};
    Object.keys(backupFlags).forEach((key) => {
      ff[key] = {
        enabled: backupFlags[key],
        users: "",
      };
    });
    return ff;
  }, []);
  const [flags, setFlags] = useState(backUpFeatureFlags);

  const init = useCallback(async () => {
    try {
      const db = firebase.firestore();
      const flagRef = db.collection("feature-flags/mf-bos/pages");
      const snapshot = await flagRef.get();
      const fetchedFlags = {};
      snapshot.forEach((doc) => {
        fetchedFlags[doc.id] = doc.data();
      });
      setFlags(fetchedFlags);
    } catch (e) {
      console.error("ERROR on fetching Feature Flags", e);
      if (!Object.keys(flags).length) {
        setFlags(backUpFeatureFlags);
      }
    }
  }, [flags, backUpFeatureFlags]);

  useMount(() => {
    init();
  });

  const featureFlags = useMemo(() => {
    const obj = {};
    Object.keys(flags).forEach((key) => {
      const flag = flags[key];
      let granted = false;
      if ((userEmail && flag.users?.split(",").includes(userEmail)) || flag.enabled) granted = true;
      obj[key] = granted;
    });
    return obj;
  }, [userEmail, flags]);

  return {
    hasFeature: (flag) => {
      return Object.keys(featureFlags).includes(flag) ? featureFlags[flag] : true;
    },
    setUserEmail: (u) => {
      setUserEmail(u);
    },
  };
};

export default useFeatureFlag;
